module.exports = __webpack_public_path__ + "img/52.67aa1302.jpg";